/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsDelete } from "../../funcs/llmPromptsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeletePromptRequest$inboundSchema,
};

export const tool$llmPromptsDelete: ToolDefinition<typeof args> = {
  name: "llm-prompts-delete",
  description: `Delete a prompt

Deletes a prompt and all its versions.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
